import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class AtomsFormsToggleIndexComponent extends Component {
  @action
  toggleChecked() {
    this.args?.onChange(!(this.args.checked ?? false));
  }
}
